<crm-single-select
  [options]="options"
  [(selectedItem)]="type"
  (selectedItemChange)="typeChange.emit($event)"
  [class]="class"
  [styleClass]="styleClass"
  optionValue="name"
  [filter]="false"
  [isTemplateCombined]="true"
  [appendTo]="appendTo">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type.value | deadlineMonthTypeName }}
  </ng-template>
</crm-single-select>
